module.exports = __webpack_public_path__ + "img/arrow-right-waterblue.cdfb0d87.svg";